import React from 'react';

const News = () => (
    <div>
        <h4>News</h4>
    </div>
);

export default News;



// WEBPACK FOOTER //
// ./src/components/News.js